import { Component, OnInit, OnDestroy } from '@angular/core';
import { DealerService } from '../_services/dealer-service';
import { Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { Dealer } from '@app/_models/dealer';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { AlertService } from '@app/_services';

@Component({
  selector: 'app-dealer-list',
  templateUrl: './dealer-list.component.html',
})
export class DealerListComponent implements OnInit, OnDestroy {
  dealers : Dealer[];
  serviceDealers : Dealer[];
  form: UntypedFormGroup;
  regexp: RegExp;
  idRegexp = new RegExp("",'i');
  stateRegexp = new RegExp("",'i');
  nameRegexp = new RegExp("",'i');
  cityRegexp = new RegExp("",'i');
  groupRegexp = new RegExp("",'i');
  isLoading = true;
  private destroy$ = new Subject<void>();

  constructor(private dealerService: DealerService,
    private formBuilder: UntypedFormBuilder,
    private alertService: AlertService,
    ) { }

  ngOnInit(): void {
    this.dealerService.getAll()
    .pipe(takeUntil(this.destroy$), first())
    .subscribe({
      next: (dealers) => {
        this.serviceDealers = dealers;
        this.dealers = dealers.filter(a => a.dealerCreatePackage && a.dealerPackage.length > 0);
        this.isLoading = false;
      },
      error: () => { this.alertService.error('Failed to load dealers'); this.isLoading = false; }
    });
    this.form = this.formBuilder.group({
      dealerId: [''],
      dealerName: [''],
      dealerGroupName: [''],
      dealerCity: [''],
      dealerState: [''],
      dealerType: ['Package']
    });

    this.form.get('dealerType').valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
      if(value === "All"){
        this.dealers = this.serviceDealers;
      } else if(value === "Package"){
        this.dealers = this.serviceDealers.filter(a => a.dealerCreatePackage && a.dealerPackage.length > 0);
      } else {
        this.dealers = this.serviceDealers.filter(a => a.dealerCreatePackage && a.dealerPackage.length === 0);
      }
    });

    this.form.get('dealerId').valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        this.idRegexp = new RegExp(value,'i'); 
        this.dealers = this.serviceDealers.filter(a => {
          return this.idRegexp.test(a.dealerId) && this.nameRegexp.test(a.dealerName) && this.groupRegexp.test(a.dealerGroupName) && this.cityRegexp.test(a.dealerCity);
        });
     });

     this.form.get('dealerName').valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
      this.nameRegexp = new RegExp(value,'i'); 
      this.dealers = this.serviceDealers.filter(a => {
        return this.idRegexp.test(a.dealerId) && this.nameRegexp.test(a.dealerName) && this.groupRegexp.test(a.dealerGroupName) && this.cityRegexp.test(a.dealerCity) && this.stateRegexp.test(a.dealerState);
      });
   });

   this.form.get('dealerGroupName').valueChanges
    .pipe(takeUntil(this.destroy$))
    .subscribe((value) => {
    this.groupRegexp = new RegExp(value,'i'); 
    this.dealers = this.serviceDealers.filter(a => {
      return this.idRegexp.test(a.dealerId) && this.nameRegexp.test(a.dealerName) && this.groupRegexp.test(a.dealerGroupName) && this.cityRegexp.test(a.dealerCity) && this.stateRegexp.test(a.dealerState);
    });
 });

 this.form.get('dealerCity').valueChanges
  .pipe(takeUntil(this.destroy$))
  .subscribe((value) => {
  this.cityRegexp = new RegExp(value,'i'); 
  this.dealers = this.serviceDealers.filter(a => {
    return this.idRegexp.test(a.dealerId) && this.nameRegexp.test(a.dealerName) && this.groupRegexp.test(a.dealerGroupName) && this.cityRegexp.test(a.dealerCity) && this.stateRegexp.test(a.dealerState);
  });
});

this.form.get('dealerState').valueChanges
  .pipe(takeUntil(this.destroy$))
  .subscribe((value) => {
  this.stateRegexp = new RegExp(value,'i'); 
  this.dealers = this.serviceDealers.filter(a => {
    return this.idRegexp.test(a.dealerId) && this.nameRegexp.test(a.dealerName) && this.groupRegexp.test(a.dealerGroupName) && this.cityRegexp.test(a.dealerCity) && this.stateRegexp.test(a.dealerState);
  });
});

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
